import { getPageType } from "@/getServerSideProps/params";
import { PageType } from "@/types/types";
import { useRouter } from "next/router";

export type RouteParams = {
  path: string | undefined;
  query: Record<string, string | string[] | undefined>;
  facetId: string[] | undefined;
  pageType: PageType;
  queryWithoutPage: Record<string, string | string[] | undefined>;
};

export function useRouteParams(): RouteParams {
  const { query, asPath } = useRouter();

  const { type: type, facetId: facetId, ...queryParams } = query;

  const queryWithoutPage = { ...queryParams };
  delete queryWithoutPage.page;

  return {
    path: asPath?.split("?")[0]?.split("#")[0],
    query: queryParams,
    facetId: typeof facetId === "string" ? [facetId] : facetId,
    pageType: getPageType(query) || "browse",
    queryWithoutPage,
  };
}
